export default "__VITE_ASSET__DTlJzrzc__"